import React from 'react'
import _ from 'lodash'
import Single from './Single'
import Grouped from './Grouped'

function CategoryTable(props) {
  const {install_axis} = props
  if (_.isArray(install_axis) && _.has(install_axis, '[0].detail_')) {
    return (
      <Grouped {...props} />
    )
  }
  if (_.isArray(install_axis) && _.has(install_axis, '[0].article')) {
    return (
      <Single {...props} />
    )
  }
  return null
}

export default CategoryTable



// WEBPACK FOOTER //
// ./src/finwhale/common/category/table/index.js